import { TimeQuestionConfig, TimeResponseState } from '@gripp/shared-logic';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';
import { TimeFormTypeComponents } from './executionForm/executionForm';

export const TimeQuestionExecutionForm: RoutineQuestionExecutionForm<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    TimeQuestionConfig,
    TimeResponseState
  >
) => {
  const TimeFormType = TimeFormTypeComponents[props.config.timeType];

  return <TimeFormType {...props} />;
};
